<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gs3TH/tc-custom/9781442402072.jpg?1724818070619" alt="This image is the cover for the book Enshadowed, The Nevermore Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Enshadowed, The Nevermore Books
      </h1>
      <p class="bookDescription body article font2">
        <b>True love takes a twisted turn in the second book of this modern gothic romance trilogy that channels the dark brilliance of Edgar Allan Poe.</b><br/><br/>While Varen remains a prisoner in a perilous dream world where the terrifying stories of Edgar Allan Poe come to life, Isobel travels to Baltimore to confront the dark figure known throughout the world as the Poe Toaster. This man, the same man who once appeared to Isobel in her dreams and abandoned her in Varen’s nightmare world, holds the key to saving Varen.<br/><br/>But when Isobel discovers a way to return to this dream world, she finds herself swept up in a realm that not only holds remnants of Edgar Allan Poe’s presence, but one that has taken on the characteristics of Varen’s innermost self. It is a dark world of fear, terror, and anger.<br/><br/>When Isobel once more encounters Varen, she finds him changed. And now Isobel must face a new adversary—one who also happens to be her greatest love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Creagh
      </h2>
      
      <p class="authorDescription body article">Kelly Creagh is a 2008 graduate of Spalding University&rsquo;s MFA in Creative Writing program. When not writing, haunting bookstore coffee shops, or obsessively studying Poe, Kelly&rsquo;s passions include the ancient art of bellydance. She lives with her squirrely, attitude-infused dogs&mdash;Annabel, Jack, and Holly&mdash;in the heart of Old Louisville, Kentucky&rsquo;s largest and spookiest Victorian neighborhood. Kelly is the author of the Nevermore trilogy. Visit her at KellyCreagh.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atheneum Books for Young Readers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e98445a